import { render, staticRenderFns } from "./newNotices.vue?vue&type=template&id=70d1ac5c&"
import script from "./newNotices.vue?vue&type=script&lang=js&"
export * from "./newNotices.vue?vue&type=script&lang=js&"
import style0 from "./newNotices.vue?vue&type=style&index=0&id=70d1ac5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports